import React, { useReducer, useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronLeft, ChevronRight, Send, CheckCircle, AlertCircle, Building, Users, Award, Globe, FileText, CheckSquare } from 'lucide-react';
import { SectionTitle, Row, Col, FormField, Textarea } from '../../../SharedInputs';

export function SectionCompanyOverview({ state, dispatch, errors }) {
  const updateField = (field, value) => {
    dispatch({ type: 'UPDATE_FIELD', section: 'companyOverview', field, value });
  };

  return (
    <div>
      <SectionTitle icon={FileText}>Company Overview</SectionTitle>
      
      <Row>
        <Col span={12}>
          <FormField 
            label="Services Summary" 
            required 
            error={errors.find(e => e.includes('Services summary'))}
            hint="Please provide a summary of the services your company offers"
          >
            <Textarea
              value={state.companyOverview.servicesSummary}
              onChange={(e) => updateField('servicesSummary', e.target.value)}
              placeholder="Describe your services..."
              rows={4}
            />
          </FormField>
        </Col>
      </Row>

      <Row>
        <Col span={12}>
          <FormField 
            label="Company Structure" 
            required 
            error={errors.find(e => e.includes('Company structure'))}
            hint="Describe your company structure and organization"
          >
            <Textarea
              value={state.companyOverview.companyStructure}
              onChange={(e) => updateField('companyStructure', e.target.value)}
              placeholder="Describe your company structure..."
              rows={4}
            />
          </FormField>
        </Col>
      </Row>
    </div>
  );
}